import React, { useContext } from 'react';

import { useIntl } from 'react-intl';

import { ConcertDetails as ConcertDetailsInterface, Tour } from 'interfaces';

import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Title from 'components/ui/Title';
import SongsList from 'components/SongsList';

import {
  Wrapper,
  ShowDetailsList,
  ShowDetailsListItem,
  NoteWrapper,
  DescriptionWrapper
} from './ConcertDetails.styles';

export interface TourDetailsProps {
  tour?: Tour;
  concert: ConcertDetailsInterface;
  setList: unknown[];
}

const ConcertDetails = ({ tour, concert, setList }: TourDetailsProps) => {
  const { locale } = useContext(LanguageContext);
  const intl = useIntl();

  return (
    <Wrapper>
      {
        tour ? (
          <Title size="normal" color="primary" noMargin>
            {intl.formatMessage({ id: 'tours.tour.title' }, {
              tour: locale === AppLocale.EN ? tour.englishName || tour.name : tour.name
            })}
          </Title>
        ) : null
      }
      <Title size="big" color="secondary">
        {intl.formatMessage({ id: 'tours.concert.title' })}
        {intl.formatMessage({ id: 'concert.name' }, {
          bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP,
          name: concert.name ? `${intl.formatMessage({ id: `concert.name.${concert.name}` })}${locale === AppLocale.EN ? ', ' : '、'}` : '',
          venue: intl.formatMessage({ id: `concert.venue.${concert.venueId}` }),
          city: intl.formatMessage({ id: `concert.city.${concert.cityId}` }),
          country: intl.formatMessage({ id: `concert.country.${concert.countryId}` })
        })}
      </Title>
      <ShowDetailsList>
        <ShowDetailsListItem>
          {intl.formatMessage({ id: 'tours.concert.date' })} {intl.formatDate(new Date(concert.date), {
          year: 'numeric', month: 'short', day: 'numeric'
        })}
        </ShowDetailsListItem>
       <ShowDetailsListItem>
         {intl.formatMessage({ id: 'tours.concert.venue' }, {
           venue: intl.formatMessage({ id: `concert.venue.${concert.venueId}` }),
           city: intl.formatMessage({ id: `concert.city.${concert.cityId}` }),
           country: intl.formatMessage({ id: `concert.country.${concert.countryId}` })
         })}
       </ShowDetailsListItem>
      </ShowDetailsList>
      {
        concert.description.length ? (
          <DescriptionWrapper>
            <Title>{intl.formatMessage({ id: `concert.descriptions.title` })}</Title>
            {
              concert.description.map((desc, index) => (
                <p key={index}>
                  {intl.formatMessage({ id: `concert.descriptions.${concert.id}.${desc}` }, {
                    bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
                  })}
                </p>
              ))
            }
          </DescriptionWrapper>
        ) : null
      }
      <Title color="secondary">{intl.formatMessage({ id: `concert.setList.title` })}</Title>
      <SongsList songs={setList} listType="concert" />
      {
        setList.length && !concert.setListConfirmed ? (
          <NoteWrapper>{intl.formatMessage({ id: 'concert.unconfirmedNote' })}</NoteWrapper>
        ) : null
      }
      {
        !setList.length ? (
          <NoteWrapper>{intl.formatMessage({ id: 'concert.noSetlist' })}</NoteWrapper>
        ) : null
      }
    </Wrapper>
  );
};

export default ConcertDetails;
